/**
 * A sticky scroll carousel reserves one card height per unit of transition weight, plus the
 * viewport the last card is read in.
 *
 * `useVerticalScrollCarousel` computes it from measured values once mounted; a server render
 * can measure nothing, so it expresses the same formula in CSS. Both go through here so the
 * two cannot drift — and a drift is not cosmetic: it puts the page back to growing by
 * thousands of pixels the moment the carousel mounts, dragging everything below it, including
 * the footer form, out from under the reader. See JLG4-239.
 */
export function scrollRunwayHeight(
  cardHeight: number,
  totalWeight: number,
  viewportHeight: number
): number {
  return cardHeight * totalWeight + viewportHeight;
}

/**
 * CSS mirror of `scrollRunwayHeight`. `cardHeight` is any CSS length — a measured constant,
 * `100vh` when the sticky container is `h-screen`, or a custom property that steps at
 * breakpoints. The viewport term is always `100vh`.
 */
export function scrollRunwayCss(cardHeight: string, totalWeight: number): string {
  if (totalWeight <= 0) return '100vh';
  return `calc(${cardHeight} * ${totalWeight} + 100vh)`;
}
